import React, { useState } from "react";

const ViewScheduleTable = ({schedule,isMobile}) => {
    const [schd,setSchd] = useState(false);

    const convertCurrency = (a) => {
      let aTemp =  parseFloat(a);
      return aTemp.toLocaleString('en-IN');
    };

    return (
      <div className="mt-4 viewSchedule">
        <div className="row rowGutter">
          <div className="col-12 col-md-4 col-lg-8"></div>

          <div className="col-md-4 col-lg-2 text-right"></div>

          <div className="col-lg-2 mb-3 col-md-4 text-right">
            <button className="download-btn col-12" onClick={() => setSchd(!schd)}>{!schd ? "View" : "Hide" } Schedule</button>
          </div>
        </div>

        {schd &&
        <div className="col-md-12  d-flex">
          <div className="table-responsive tableFixHead">
            <table className="table table-striped viewScheduleTable">
              {!isMobile &&
              <thead>
                <tr>
                  <th scope="col">Schedule Date</th>
                  <th scope="col">Schedule Amount</th>
                  <th scope="col">Principal</th>
                  <th scope="col">Interest</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              }
              <tbody>
                {schedule && Object.keys(schedule).map((i)=>
                  <>
                  {!isMobile &&
                  <tr key={"sh"+i}>
                    <td>{schedule[i].schedule_date}</td>
                    <td>₹{convertCurrency(schedule[i].schedule_payment_amount)}</td>
                    <td>₹{convertCurrency(schedule[i].schedule_principal_amount)}</td>
                    <td>₹{convertCurrency(schedule[i].schedule_interest_amount)}</td>
                    <td>{schedule[i].is_paid === true ? "Paid": "Unpaid"}</td>
                  </tr>
                  }
                  {isMobile &&
                  <tr key={"sh"+i}>
                  <td>
                      <div className="d-flex d-All">
                          <div className="d-lable">Schedule Date</div>
                          <div className="dataF">{schedule[i].schedule_date}</div>
                      </div>
                      <div className="d-flex d-All">
                          <div className="d-lable">Schedule Amount</div>
                          <div className="dataF">₹{convertCurrency(schedule[i].schedule_payment_amount)}</div>
                      </div>
                      <div className="d-flex d-All">
                          <div className="d-lable">Principal</div>
                          <div className="dataF">₹{convertCurrency(schedule[i].schedule_principal_amount)}</div>
                      </div>
                      <div className="d-flex d-All">
                          <div className="d-lable">Interest</div>
                          <div className="dataF">₹{convertCurrency(schedule[i].schedule_interest_amount)}</div>
                      </div>
                      <div className="d-flex d-All">
                          <div className="d-lable">Status</div>
                          <div className="dataF">{schedule[i].is_paid === true ? "Paid": "Unpaid"}</div>
                      </div>
                  </td>
                  </tr>
                  }
                  </>
                )}
              </tbody>
            </table>
          </div>
        </div>
        }
        {/*<div className="row rowGutter">
          <div className="col-12 col-md-4 col-lg-8">&nbsp;</div>

          <div className="col-md-4 col-lg-2 my-md-4 text-right">
            <select className="select-custom mt-2 col-12">
              <option defaultValue>Select Format CSV</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>
          </div>

          <div className="col-lg-2 mb-3 col-md-4 my-md-4 text-right">
            <button className="download-btn mt-2 col-12">
              <img
                src="/images/StatementOfAccount/download.svg"
                alt="download"
                width="20px"
              />{" "}
              Download
            </button>
          </div>
        </div>*/}
      </div>
    );
}
export default ViewScheduleTable;
